export interface RequestPage {
    pageSize: number;
    pageNumber: number;
    pageType: number;
}

export interface ResponsePage<T> {
  list: T[];
  totalRow: number;
  pageSize: number;
  pageNumber: number;
  extraData?: any;
  lastPage: boolean;
  totalPage: number;
  firstPage: boolean;
}

/** 构建 GET 分页 query 参数（与 core PageEntity 字段一致） */
export function buildPageQueryParams(pageNumber: number, pageSize: number, pageType = 1): URLSearchParams {
  return new URLSearchParams({
    pageNumber: String(pageNumber),
    pageSize: String(pageSize),
    pageType: String(pageType),
  });
}